import { ANCHOR_LINK } from './data-hooks';

export const LINK_PARSE_HTML_TAG = `a[href]:not([href *= "javascript:" i]):not([data-hook~=${ANCHOR_LINK}])`;
